import { getFirebaseAuth } from "../Firebase/getFirebaseAuth";
import { useEffect, useState } from "react";
import { User } from "@firebase/auth";

export function useFirebaseUser() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = getFirebaseAuth().onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { user, loading };
}
